import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import CollectedComponent from './collected.component';

let CollectedModule = angular
  .module('Collected', [
    uiRouter
  ])
  .component('collected', CollectedComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('collected', {
      url: '/collected',
      data: {
        authRequired: true,
        permsRequired: ['view-journals']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'collected'
        }
      },
      resolve: {
        collectedObservable: (ContentService, ProfilePermissionsService) => {
          return ProfilePermissionsService.hasPermission('view-journals') ? ContentService.getJournalFiles() : {};
        }
      }
    })
  })
  .name;

export default CollectedModule;



// WEBPACK FOOTER //
// ./src/app/pages/collected/collected.module.js